export default __webpack_public_path__ + "static/media/Ies_MesasCruzadas_CarrieACCESO_eng.d36f40f8.jpg";